import { twMerge } from 'tailwind-merge';
import { PropsWithChildren } from 'react';

import { TopNavigation } from 'components';

import { Background } from '../background';

export const PrivateLayout = ({
  children,
  backgroundClassName,
}: PropsWithChildren<{ backgroundClassName?: string }>) => (
  <div className="flex min-h-screen w-screen">
    <Background
      className={twMerge(
        'fixed top-0 bottom-0 left-0 w-screen',
        backgroundClassName
      )}
    />
    <div className="relative z-10 flex w-full flex-col">
      <div className="border-gray-primary bg-white-primary sticky top-0 left-0 z-20 border-b-[1.5px]">
        <Wrapper>
          <TopNavigation />
        </Wrapper>
      </div>
      <Wrapper className="flex min-h-0 flex-1 flex-col pt-2 md:px-10 md:pt-4">
        {children}
      </Wrapper>
    </div>
  </div>
);

const Wrapper = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => (
  <div
    className={twMerge(
      'w-full px-6 lg:mx-auto lg:max-w-[calc(1312px+(--spacing(12)))]',
      className
    )}
  >
    {children}
  </div>
);
